import { render, staticRenderFns } from "./AdminTicket.vue?vue&type=template&id=615d93a7&scoped=true"
import script from "./AdminTicket.vue?vue&type=script&lang=js"
export * from "./AdminTicket.vue?vue&type=script&lang=js"
import style0 from "./AdminTicket.vue?vue&type=style&index=0&id=615d93a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615d93a7",
  null
  
)

export default component.exports